import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';

const CustomDate = React.memo(({ date, format }) => {
  let yyyy;
  let MM;
  let dd;
  let hh;
  let mm;
  let ss;

  if (date) {
    const dateString2 = moment(date).utc().utcOffset('+02:00');

    yyyy = new Date(dateString2).getFullYear().toString();
    MM = (new Date(dateString2).getMonth() + 1).toString();
    dd = new Date(dateString2).getDate().toString();
    hh = new Date(dateString2).getHours().toString();
    mm = new Date(dateString2).getMinutes().toString();
    ss = new Date(dateString2).getSeconds().toString();
  }

  if (MM < 10) { MM = 0 + MM; }
  if (dd < 10) { dd = 0 + dd; }
  if (hh < 10) { hh = 0 + hh; }
  if (mm < 10) { mm = 0 + mm; }
  if (ss < 10) { ss = 0 + ss; }

  let dateString = format.replace('YYYY', yyyy);
  dateString = dateString.replace('MM', MM);
  dateString = dateString.replace('DD', dd);
  dateString = dateString.replace('hh', hh);
  dateString = dateString.replace('HH', hh);
  dateString = dateString.replace('mm', mm);
  dateString = dateString.replace('ss', ss);

  return (
    <div>
      {dateString}
    </div>
  );
});

CustomDate.propTypes = {
  date: PropTypes.number,
  format: PropTypes.string,
};

CustomDate.defaultProps = {
  date: null,
  format: '',
};

export default CustomDate;
